import { createSlice } from "@reduxjs/toolkit";

const initialState = {

    //get equity data 
    equityData: [],
    equityDataSuccess: false,
    equityDataError: null,
    equityDataLoading: false,

    //get challenge stage info
    challengeStageInfo: {},
    challengeStageInfoSuccess: false,
    challengeStageInfoError: null,
    challengeStageInfoLoading: false,
    challengeCurrency: "",
    challengeCredentials: {},

    //get stages by challenge
    stages:[],
    stagesSuccess:false,
    stagesError:null,
    stagesLoading:false,
    

    // get challenges list
    challenges: [],
    challengesSuccess: false,
    challengesError: null,
    challengesLoading: false,




};

const ChallengeOverviewReducer = createSlice({
    name: "Challenge Overview",
    initialState,
    reducers: {

        //get equity data
        getEquityDataRequest: (state) => {
            state.equityDataLoading = true;
            state.equityDataError = null;
            state.equityDataSuccess = false;
            state.equityData = [];
        },
        getEquityDataSuccess: (state, { payload }) => {
            state.equityData = payload;
            state.equityDataLoading = false;
            state.equityDataError = null;
            state.equityDataSuccess = true;
        },
        getEquityDataError: (state, { payload }) => {
            state.equityDataLoading = false;
            state.equityDataError = payload;
            state.equityDataSuccess = false;
            state.equityData = [];
        },

        //get challenge stage info
        getChallengeStageInfoRequest: (state) => {
            state.challengeStageInfoLoading = true;
            state.challengeStageInfoError = null;
            state.challengeStageInfoSuccess = false;
            state.challengeStageInfo = {};
        },
        getChallengeStageInfoSuccess: (state, { payload }) => {
            state.challengeStageInfo = payload;
            state.challengeStageInfoLoading = false;
            state.challengeStageInfoError = null;
            state.challengeCurrency=payload.Challenge.Currency.symbol;
            state.challengeCredentials=payload.Account
            state.challengeStageInfoSuccess = true;
        },
        getChallengeStageInfoError: (state, { payload }) => {
            state.challengeStageInfoLoading = false;
            state.challengeStageInfoError = payload;
            state.challengeStageInfoSuccess = false;
            state.challengeStageInfo = {};
        },

        //get stages by challenge
        getStagesRequest: (state) => {
            state.stagesLoading = true;
            state.stagesError = null;
            state.stagesSuccess = false;
            state.stages = [];
        },
        getStagesSuccess: (state, { payload }) => {
            state.stages = payload;
            state.stagesLoading = false;
            state.stagesError = null;
            state.stagesSuccess = true;
        },
        getStagesError: (state, { payload }) => {
            state.stagesLoading = false;
            state.stagesError = payload;
            state.stagesSuccess = false;
            state.stages = [];
        },

     


        //get challenges list
        getChallengesRequest: (state) => {
            state.challengesLoading = true;
            state.challengesError = null;
            state.challengesSuccess = false;
            state.challenges = [];
        },
        getChallengesSuccess: (state, { payload }) => {
            state.challenges = payload;
            state.challengesLoading = false;
            state.challengesError = null;
            state.challengesSuccess = true;
        },
        getChallengesError: (state, { payload }) => {
            state.challengesLoading = false;
            state.challengesError = payload;
            state.challengesSuccess = false;
            state.challenges = [];
        },


        //clear states
        clearStates: (state) => {
            state.equityDataSuccess = false;
            state.equityDataError = null;

            state.challengeStageInfoSuccess = false;
            state.challengeStageInfoError = null;

            state.stagesSuccess = false;
            state.stagesError = null;

            state.challengesSuccess = false;
            state.challengesError = null;

            state.payablePaymentSuccess = false;
            state.payablePaymentError = null;   

        },



    }
})


export const ChallengeOverviewActions = ChallengeOverviewReducer.actions;

export default ChallengeOverviewReducer.reducer;
